export default "<app-header></app-header>\n<div class=\"content\">\n  <router-outlet></router-outlet>\n</div>"